module.exports = __webpack_public_path__ + "static/visionar_case_study_ar-for-interactive-fashion-magazine-400x284-94e1eb59d758e034d8d94f7642a7b821.jpg";